<template>
  <div class="business">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="2"></menuBox>
      <div class="banner-text">
        <div class="title">tentang kami</div>
      </div>
    </div>
    <div class="solutions-box">
      <div class="title">
        Didorong oleh inovasi, kualitas terjamin, pilihan terbaik yang layak Anda dapatkan.
      </div>
      <div class="banner-list">
        <div class="item">
          <img src="../assets/business-4.png" alt="" />
          <div class="title">
            Berbagai produk yang kaya
          </div>
          <div class="text">
            Tidak ada batasan area bisnis untuk toko fisik, dan berbagai produk dalam dan luar negeri dapat dipajang untuk memenuhi kebutuhan konsumen yang berbeda.
          </div>
        </div>
        <div class="item">
          <img src="../assets/business-5.png" alt="" />
          <div class="title">
            Pembayaran dan logistik yang efisien
          </div>
          <div class="text">
            Mendukung berbagai metode pembayaran dan bekerja sama dengan perusahaan logistik global untuk memastikan layanan pengiriman yang cepat dan aman
          </div>
        </div>
        <div class="item">
          <img src="../assets/business-6.png" alt="" />
          <div class="title">
            Rekomendasi yang dipersonalisasi
          </div>
          <div class="text">
            Memberikan rekomendasi produk yang dipersonalisasi kepada pengguna dan meningkatkan pengalaman berbelanja melalui teknologi analisis data canggih
          </div>
        </div>
      </div>
    </div>
    <div class="mission-box">
      <img src="../assets/mession-2.png" alt="" />
      <div class="content">
        <div class="title">
          Pengalaman berbelanja yang luar biasa, nikmati setiap pilihan dengan tenang
        </div>
        <div class="text">
          Sejak didirikan, kami selalu berpegang pada prinsip "mengutamakan pelanggan" dan memenuhi kebutuhan konsumen melalui inovasi teknologi dan riset pasar yang berkelanjutan. Tim kami terdiri dari sekelompok profesional yang bersemangat dan kreatif yang berkomitmen untuk membangun platform belanja yang efisien, nyaman, dan aman untuk memberikan pengalaman yang baik kepada pengguna.
        </div>
        <div class="list">
          <p><img src="../assets/right-icon-1.png" alt="">Kami telah menjalin hubungan kerja sama yang erat dengan pemasok di seluruh dunia dan mampu menyediakan berbagai produk dan barang untuk memenuhi kebutuhan pelanggan. Kami secara ketat mengontrol kualitas produk kami dan menjaga harga yang kompetitif untuk memastikan Anda mendapatkan manfaat maksimal.</p>
          <p><img src="../assets/right-icon-2.png" alt="">Kami akan terus bekerja keras untuk meningkatkan pengalaman pengguna, memperluas cakupan bisnis global, dan berusaha menjadi platform e-commerce internasional terkemuka. Kami percaya bahwa melalui upaya dan inovasi yang berkelanjutan, kami dapat menyediakan produk dan layanan yang lebih baik kepada lebih banyak pengguna.</p>
        </div>
      </div>

    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";
  export default {
    name: "App",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {
      aboutUs() {
        this.$router.push({ path: "aboutUs" });
      },
    },
  };
</script>
<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-2.png);
    height: 620px;
    background-size: 100% 100%;

    .banner-text {
      margin: 0 360px;
      padding-top: 100px;
      text-align: left;
      margin-top: 100px;

      .title {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 80px;
        color: #333333;
      }

      .text {
        font-size: 26px;
        font-weight: 400;
        font-size: 22px;
        color: #333333;
        margin-top: 20px;
      }
    }
  }

  .solutions-box {
    padding: 100px 360px;

    .title {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 52px;
      color: #252B42;
      text-align: center;
    }

    .banner-list {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      margin-top: 100px;

      .item {

        img {
          width: 380px;
          height: 400px;
        }

        .title {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 32px;
          color: #333333;
          width: 360px;
          padding-top: 25px;
          text-align: left;
        }

        .text {
          font-family: HelveticaNeue;
          font-size: 20px;
          color: #999999;
          width: 340px;
          border-radius: 0 0 20px 20px;
          text-align: left;
          margin-top: 20px;
        }
      }
    }
  }

  .mission-box {
    padding: 50px 360px;
    padding-left: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .content {
      width: 580px;

      .title {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 46px;
        color: #333333;
        margin-bottom: 50px;
      }

      .text {
        font-family: HelveticaNeue;
        font-size: 18px;
        color: #333333;
      }

      .list {
        margin-top: 50px;

        p {
          font-family: HelveticaNeue;
          font-size: 20px;
          color: #333333;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
        }

        img {
          width: 92px;
          height: 92px;
          vertical-align: middle;
          margin-right: 40px;
        }
      }
    }

    img {
      width: 869px;
      height: 835px;
    }
  }
</style>